import axios from "axios";

export const getLocationData = async ({lat, lng}) => {
  try{
      const apiKey = process.env.REACT_APP_BIGDATA_API_KEY;
      const response = await axios.get(`https://api-bdc.net/data/reverse-geocode?latitude=${lat}&longitude=${lng}&localityLanguage=en&key=${apiKey}`);
      return response;
  }
  catch(error){
      return null;
  }
}


export const getGeolocation = async () => {
  try {
      const response = await axios.post(`https://www.googleapis.com/geolocation/v1/geolocate?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`, {
          // Use an empty payload to let the API determine location from Wi-Fi, cell towers, etc.
          //considerIp: true
      });

      return response.data.location;

  } catch (error) {
      console.error("Error getting geolocation: ", error.response.data.error.message);
      return null;
  }
}

// Reverse geocode coordinates to a human-readable street-level address when available.
export const getPreciseAddressFromCoordinates = async ({ lat, lng }) => {
  try {
      const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
      if (!apiKey || lat == null || lng == null) {
          return null;
      }
      const response = await axios.get(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${apiKey}`
      );

      const first = Array.isArray(response?.data?.results) ? response.data.results[0] : null;
      const formattedAddress = first?.formatted_address;
      return formattedAddress || null;
  } catch (error) {
      return null;
  }
}


export const findNearestLocations = (currentLocation, topNearest, facilitiesSummary) => {
    if (process.env.REACT_APP_NODE_ENV !== 'production') console.log(currentLocation);
    if(!currentLocation){
        return null;
    }
    const sortedLocations = Array.isArray(facilitiesSummary)
        ? facilitiesSummary.map((location) => {
            const distance = haversineDistance(currentLocation, location);
            return { ...location, distance };
        }).sort((a, b) => a.distance - b.distance)
        : [];
    return sortedLocations.slice(0, topNearest);
};

const haversineDistance = (loc1, loc2) => {
  const R = 6371; // Radius of the Earth in km
  const dLat = (loc2.lat - loc1.lat) * (Math.PI / 180);
  const dLng = (loc2.lng - loc1.lng) * (Math.PI / 180);
  const a =
  Math.sin(dLat / 2) * Math.sin(dLat / 2) +
  Math.cos(loc1.lat * (Math.PI / 180)) * Math.cos(loc2.lat * (Math.PI / 180)) *
  Math.sin(dLng / 2) * Math.sin(dLng / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c; // Distance in km
};
